import { slideUp, slideDown } from "es6-slide-up-down";

export default class Products {
	constructor() {
		this.filters = document.getElementById("filters");
		this.init();
	}

	init() {
		this.toggleFilters();
		this.productAttributes();
	}

	toggleFilters() {
		if (this.filters) {
			const toggle = this.filters.querySelector(".filters--toggle");
			const selectors = this.filters.querySelector(".filters--selectors");
			const params = window.location.search;

			if (toggle && selectors) {
				if (params) {
					toggle.classList.add("active");
					selectors.classList.add("active");
					selectors.style.display = "block";
				}

				toggle.addEventListener("click", (e) => {
					if (selectors.classList.contains("active")) {
						selectors.classList.remove("active");
						selectors.classList.remove("active");
						slideUp(selectors);
					} else {
						toggle.classList.add("active");
						selectors.classList.add("active");
						slideDown(selectors);
					}
					e.preventDefault();
				});
			}
		}
	}

	productAttributes() {
		const productAttributesTables = document.querySelectorAll("table.woocommerce-product-attributes");
		if (productAttributesTables) {
			productAttributesTables.forEach((item) => {
				const productAttributesTableValues = item.querySelectorAll(".woocommerce-product-attributes-item__value");
				if (productAttributesTableValues) {
					productAttributesTableValues.forEach((item) => {
						let content = item.innerHTML;
						item.innerHTML = content.split(", ").join("<br>");
					});
				}
			});
		}
	}
}
